<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-tabla-gestiones"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import { cellRendererNumeroRegistro } from '../utils';
import ListadoAgGridMixin from './../mixins/listado-ag-grid-mixin';

export default {
  name: 'ListadoGrupo',
  mixins: [ListadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'NRO. REG.',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'CÓDIGO',
          field: 'codigo',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'NOMBRE',
          field: 'nombre',
          filter: false,
          minWidth: 150,
        },
        {
          headerName: 'GRUPO PADRE',
          cellRenderer: (params) => {
            if (!params.data.grupo) {
              return '';
            }

            return /*html*/ `<small>${params.data.grupo?.codigo} ${params.data.grupo?.nombre}</small>`;
          },
          filter: false,
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'DESCRIPCIÓN',
          field: 'descripcion',
          filter: false,
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'CREADO EN',
          field: 'creado_en',
          filter: false,
          minWidth: 250,
          maxWidth: 250,
        },
        {
          headerName: 'ACTUALIZADO EN',
          field: 'actualizado_en',
          filter: false,
          minWidth: 250,
          maxWidth: 250,
        },
      ],
    };
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-tabla-gestiones {
  height: calc(var(--vh, 1vh) * 100 - 16rem);
}
</style>
  